const PIXEL_ID = '1545009850674181'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

/**
 * Loads the official Meta (Facebook) Pixel base code and initializes the pixel.
 * Safe to call multiple times — it only injects/initializes once.
 * All work is wrapped in try/catch so a blocked or failing external
 * script (e.g. ad blockers, sandboxed preview iframes) can never break the app.
 */
export function initFacebookPixel(): void {
  if (typeof window === 'undefined' || initialized) return

  try {
    /* eslint-disable */
    ;(function (f: any, b, e, v, n?: any, t?: any, s?: any) {
      if (f.fbq) return
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []
      t = b.createElement(e)
      t.async = !0
      t.src = v
      // Swallow any load error from the external script so it stays non-fatal.
      t.onerror = function () {}
      s = b.getElementsByTagName(e)[0]
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s)
      } else {
        ;(b.head || b.documentElement).appendChild(t)
      }
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )
    /* eslint-enable */

    if (window.fbq) {
      window.fbq('init', PIXEL_ID)
      initialized = true
    }
  } catch (err) {
    // Never let analytics break the page.
    // eslint-disable-next-line no-console
    console.warn('Facebook Pixel could not be initialized:', err)
  }
}

/**
 * Fires a standard or custom Meta Pixel event. Never throws.
 */
export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  try {
    if (typeof window === 'undefined' || !window.fbq) return
    window.fbq('track', event, params)
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('Facebook Pixel event failed:', event, err)
  }
}
